/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'
import Img from 'components/Img'
// import Logo from 'components/ui/Logo'

// import Ratio from 'components/Ratio'

import ZoomPhoto from 'images/zoom.svg'


import './style'
import './media'

/*Images*/

const PhotoItem = props =>(
    <div className={c("photo-item", props.className)} onClick={()=>props.onClick(props.id)}>
        <div className="photo-item__main-wrapper">
            <div className="photo-item__wrapp">
                <div className="photo-item__overlay">
                    <Img src={ZoomPhoto} className="zoom-photo"/>
                </div>
                {props.image}
            </div>
            <div className="photo-item__title">
                {props.title}
            </div>
        </div>
    </div>
)

export default PhotoItem